import { render } from "./AboutPage.vue?vue&type=template&id=806e4afc"
const script = {}

import "./AboutPage.vue?vue&type=style&index=0&id=806e4afc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__